export const AUTH_INIT = 'AUTH_INIT';
export const AUTH_GET_USER = 'AUTH_GET_USER';
export const AUTH_SET_STATE = 'AUTH_SET_STATE';
export const AUTH_SIGN_UP = 'AUTH_SIGN_UP';
export const AUTH_SIGN_IN = 'AUTH_SIGN_IN';
export const AUTH_SIGN_OUT = 'AUTH_SIGN_OUT';
export const AUTH_FORGOT_PASSWORD = 'AUTH_FORGOT_PASSWORD';
export const AUTH_CHANGE_PASSWORD = 'AUTH_CHANGE_PASSWORD';
export const AUTH_COMPLETE_NEW_PASSWORD = 'AUTH_COMPLETE_NEW_PASSWORD';



// WEBPACK FOOTER //
// ./src/redux/sagas/aws-cognito-redux-saga/actions.js